import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { DESTINATIONS, IMAGES } from "../mock";
import { ArrowUpRight, Clock } from "lucide-react";

const destImages = {
  "cancun-hz": IMAGES.cancun,
  "puerto-morelos": IMAGES.playa,
  "playa-del-carmen": IMAGES.playa,
  "puerto-aventuras": IMAGES.akumal,
  akumal: IMAGES.akumal,
  tulum: IMAGES.tulum,
};

const DestinationTransfers = ({ onSelect }) => {
  const { t } = useLanguage();

  return (
    <section className="bg-gradient-to-b from-teal-50/60 to-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-teal-600 font-bold text-sm uppercase tracking-widest">
            Cancún & Riviera Maya
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0d3b43] mt-2">
            {t("destTitle")}
          </h2>
          <p className="text-slate-500 mt-3">{t("destSub")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {DESTINATIONS.map((d) => (
            <button
              key={d.id}
              onClick={() => onSelect && onSelect(d.id)}
              className="group text-left relative rounded-2xl overflow-hidden rc-shadow hover:rc-shadow-lg transition-all duration-300 h-56"
            >
              <img
                src={destImages[d.id]}
                alt={d.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d3b43]/90 via-[#0d3b43]/30 to-transparent" />
              <div className="absolute inset-0 p-5 flex flex-col justify-end">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-display font-bold text-white text-xl">
                      {d.name}
                    </h3>
                    <p className="text-white/80 text-sm">{t("privateTransfers")}</p>
                  </div>
                  <span className="w-10 h-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white group-hover:bg-orange-500 transition-colors">
                    <ArrowUpRight className="w-5 h-5" />
                  </span>
                </div>
                <div className="mt-3 flex items-center gap-3">
                  <span className="flex items-center gap-1.5 text-xs text-white/85 bg-white/15 backdrop-blur px-2.5 py-1 rounded-full">
                    <Clock className="w-3.5 h-3.5" /> {d.minutes} {t("min")}
                  </span>
                  <span className="text-xs text-white/85 bg-white/15 backdrop-blur px-2.5 py-1 rounded-full">
                    {t("from")} ${d.vanRT} USD
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationTransfers;
